
import { ExcelMapperCol } from "@/utils/excel-mapper/excel-mapper-col";
import AppEditSettings from "./ExcelMapperSettingsEditColumnSetting.vue";
import AppValueAutocomplete from "./ExcelMapperSettingsEditColumnValueAutocomplete.vue";
import Vue from "vue";

export default Vue.extend({
	data(){
		return {
			column: new ExcelMapperCol()
		};
	},
	props: {
		value: {
			type: Object as ()=>ExcelMapperCol,
			required: true
		},
		knownHeaders: {
			type: Array as ()=>string[],
			required: true
		},
		allowedOutputHeaders: {
			type: Array as ()=>string[],
			required: true
		}
	},

	watch: {
		value: {
			immediate: true,
			handler(){
				this.column = new ExcelMapperCol(this.value.getJSON());
				this.column.uid = this.value.uid;
			}
		}
	},
	methods: {
		close(){
			this.$emit("close");
		},
		confirm(){
			let result = new ExcelMapperCol(this.column.getJSON());
			result.uid = this.value.uid;
			this.$emit("input", result);
			this.close();
		},
	},
	components: {
		AppEditSettings,
		AppValueAutocomplete
	},
	i18nEx: {
		componentPrefix: "components.excel-mapper"
	}
});
